import { conexaoDB } from "./db";

async function saveClientes(clientes) {
  const db = await conexaoDB();
  const objectStore = db
    .transaction(["clientes"], "readwrite")
    .objectStore("clientes");
  objectStore.clear();
  clientes.forEach((cli) => {
    objectStore.add(cli);
  });
}

async function saveProdutosPendentes(produtos) {
  const db = await conexaoDB();
  const objectStore = db
    .transaction(["produtos-pendentes"], "readwrite")
    .objectStore("produtos-pendentes");
  objectStore.clear();
  produtos.forEach((prod) => {
    objectStore.add(prod);
  });
}

async function getClientesDB() {
  const db = await conexaoDB();
  return new Promise((resolve) => {
    const query = db.transaction(["clientes"]).objectStore("clientes").getAll();
    query.onsuccess = (event) => {
      resolve(JSON.parse(JSON.stringify(event.target.result)));
    };
  });
}

async function getProdutosEmAbertoDB() {
  const db = await conexaoDB();
  return new Promise((resolve) => {
    const query = db
      .transaction(["produtos-pendentes"])
      .objectStore("produtos-pendentes")
      .getAll();
    query.onsuccess = (event) => {
      resolve(JSON.parse(JSON.stringify(event.target.result)));
    };
  });
}

export {
  saveClientes,
  saveProdutosPendentes,
  getClientesDB,
  getProdutosEmAbertoDB,
};
